import { RunQueryFor, } from "./runQueryFn";
import { ApiBuilder, } from "./apiBuilder";

/**
 * Submit phone number for SMS.
 * @param phone - phone number only digits without +7
 */
export const otpRequestMutationFn = async ({ phone, }: { phone: string },) => {
  return await RunQueryFor(ApiBuilder.mutations.otp.index(phone,),);
};

/**
 * Verify sms code
 * @param phone - phone number only digits without +7 (from initial request)
 * @param code - code from sms
 * @param passport - passport (optional)
 */
export const otpVerificationMutationFn = async ({ phone, code, passport, }: { phone: string; code: string; passport?: string },) => {
  return await RunQueryFor<{ token: string }>(ApiBuilder.mutations.otp.verifications(phone, code, passport,),);
};

/**
 * Refresh of expired token
 */
export const tokenRefreshMutationFn = async () => {
  return await RunQueryFor<{ token: string }>(ApiBuilder.mutations.token.refreshment(),);
};

export interface IPaymentMutationParams {
  operationId: string;
  paymentType: string;
  amount: number;
  paymentInstrumentId: number;
}

export const paymentMutationFn = async ({ operationId, ...rest }: IPaymentMutationParams,) => {
  return await RunQueryFor(ApiBuilder.mutations.operations.byId(operationId,).payments(rest,),);
};

export interface IDeviceMutationParams {
  fingerprint: string;
  pin: string;
}

export const addDeviceMutationFn = async ({ pin, fingerprint, }: IDeviceMutationParams,) => {
  return await RunQueryFor(ApiBuilder.mutations.devices(pin, fingerprint,),);
};

export const authDeviceMutationFn = async ({ pin, fingerprint, }: IDeviceMutationParams,) => {
  return await RunQueryFor<{ token: string }>(ApiBuilder.mutations.authenticateDevice(pin, fingerprint,),);
};

export interface IPaymentCardMutationParams {
  limitId: string;
  email: string;
}

export const cardIssuanceMutationFn = async ({ limitId, ...rest }: IPaymentCardMutationParams,) => {
  return await RunQueryFor(ApiBuilder.mutations.limits.byId(limitId,).cardIssuance(rest,),);
};

export interface ICardOtpVerificationMutationParams {
  limitId: string;
  otp: string;
}
export const cardOtpVerificationMutationFn = async ({ limitId, ...rest }: ICardOtpVerificationMutationParams,) => {
  return await RunQueryFor<{ token: string }>(ApiBuilder.mutations.limits.byId(limitId,).confirmation(rest,),);
};

export interface IQRPaymentResponse {
  amount: number;
  amountCustom: boolean;
  currency: string;
  description: string;
  id: number;
  precheckId: string;
}
export const createQrPaymentMutationFn = async ({ qrPayload, }: { qrPayload: string },) => {
  return await RunQueryFor<IQRPaymentResponse>(ApiBuilder.mutations.qr.index(qrPayload,),);
};

export interface IQRPaymentMutationParams {
  paymentId: number;
  precheckId: string;
  amount?: number;
}

export const qrPaymentMutationFn = async ({ paymentId, ...rest }: IQRPaymentMutationParams,) => {
  return await RunQueryFor<{ status: string }>(ApiBuilder.mutations.qr.byId(paymentId.toString(),).payment(rest,),);
};

export const paymentLinkMutationFn = async ({ limitId, ...rest }: { limitId: string; amount: number },) => {
  return await RunQueryFor<{ redirectUrl: string }>(ApiBuilder.mutations.limits.byId(limitId,).paymentLink(rest,),);
};

/**
 * Send email confirmation code
 * @param email - email address
 * @param params - extra params for email send request (optional)
 */
export const emailSendMutationFn = async ({ email, params, }: { email: string; params?: Record<string, string> },) => {
  return await RunQueryFor<{ token: string }>(ApiBuilder.mutations.email.send(email, params,),);
};

export interface IEmailConfirmMutationParams {
  code: string;
  consents: string[];
  token: string;
}

/**
 * Confirm email code
 * @param code - code from email
 * @param consents - array of consent strings
 * @param token - token from email.send response
 */
export const emailConfirmMutationFn = async ({ code, consents, token, }: IEmailConfirmMutationParams,) => {
  return await RunQueryFor(ApiBuilder.mutations.email.confirm(code, consents, token,),);
};
